















import { PATIENT_NOUN } from '@/constants/app-variables'

export default {
  props: {
    searchText: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: PATIENT_NOUN + ' name or number',
    },
    autofocus: Boolean,
  },
  async mounted() {
    if (this.autofocus) {
      this.$el.querySelector('.input').focus()
    }
  },
}
